import BrowserExtensionIcon from '@atlaskit/icon-lab/core/browser-extension';
import * as React from 'react';

export function SvgExtension() {
  return <BrowserExtensionIcon label="" testId="ads-refreshed-icon" />;
}
